<p-dialog
    header="{{
                nbReactions
                | i18nPlural
                : {
                        '=0': 'clubs.page.common.reactions.none' | translate,
                        '=1': 'clubs.page.common.reactions.one' | translate,
                        other: 'clubs.page.common.reactions.x' | translate
                    }
            }}"
    [(visible)]="displayModal"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="true"
    styleClass="reactions-details-modal scroller"
    appendTo="body"
>
    <ul class="p-m-0 p-p-0">
        <li *ngFor="let memberAndReaction of membersAssociatedToReactions" class="p-mb-2 reaction-detail-item">
            <div class="p-d-flex p-jc-between" *ngIf="memberAndReaction !== null">
                <div>
                    <app-list-item-user
                        [member]="memberAndReaction.member"
                        [isMemberEditable]="false"
                    ></app-list-item-user>
                </div>
                <div class="reaction-code">{{ getReactionTypeCode(memberAndReaction.reaction.reactionTypeId) }}</div>
            </div>
        </li>
    </ul>
</p-dialog>
